import { render, staticRenderFns } from "./QuestionnaireLayout.vue?vue&type=template&id=1242c7c8&scoped=true&"
import script from "./QuestionnaireLayout.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireLayout.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireLayout.vue?vue&type=style&index=0&id=1242c7c8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1242c7c8",
  null
  
)

export default component.exports